<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 15:04:51
 * @LastEditTime: 2020-09-14 16:24:27
 * @Description: 筛选条件操作栏
 -->
<template>
  <div class="filter-action-bar">
    <div class="filter-action-bar-left">
      <i-button size="small" @click="clickResetBtnHandler">重置</i-button>
      <i-button
        type="primary"
        size="small" icon="ios-search" @click="clickSearchBtnHandler">搜索</i-button>
      <i-button type="primary" size="small" @click="clickExportBtnHandler">导出</i-button>
      <i-button type="error" size="small" @click="clickDeleteBtnHandler">删除</i-button>
    </div>
    <div class="filter-action-bar-right">
      <i-input
        v-model="searchContent"
        search placeholder="输入题目内容/题目ID" @on-search="clickSearchBtnHandler" />
      <i-upload
        accept=".xls"
        :format="['xls']"
        :show-upload-list="false"
        name="file"
        :headers="{ psstoken }"
        action="/examcentersite/library/import/excel"
        :on-format-error="uploadFileFormatError"
        :before-upload="questionExcelBeforeUpload"
        :on-success="questionExcelUploaded"
        :on-error="questionExcelUploadFailed">
        <i-button type="primary" size="small">上传题目</i-button>
      </i-upload>
      <i-button
        type="primary" size="small" @click="clickWaitEditQuestionBtnHandler">待编辑题目</i-button>
    </div>
    <wait-edit-question-modal :modal="waitEditModal" @close-modal="closeWaitEditModal" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WaitEditQuestionModal from './WaitEditQuestionModal.vue';

export default {
  name: 'FilterActionBar',
  components: {
    WaitEditQuestionModal,
  },
  data() {
    return {
      searchContent: '',
      waitEditModal: false,
    };
  },
  computed: {
    ...mapGetters({
      psstoken: 'authStore/token',
      filters: 'libraryStore/filters',
      deleteIds: 'libraryStore/deleteIds',
    }),
    searchContentStore() {
      return this.$store.state.libraryStore.filters.content;
    },
  },
  watch: {
    searchContent(content) {
      this.setContentFilter({ content });
    },
    searchContentStore(content) {
      this.searchContent = content;
    },
  },
  methods: {
    ...mapActions({
      resetFilters: 'libraryStore/invokeResetFilters',
      setContentFilter: 'libraryStore/invokeSetContentFilter',
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setProcessingShowText: 'pageStore/invokeSetProcessingShowText',
    }),
    /**
     * 点击重置按钮处理函数
     */
    clickResetBtnHandler() {
      this.resetFilters();
      this.$emit('reset-filters', false);
    },
    /**
     * 点击搜索按钮处理函数
     */
    clickSearchBtnHandler() {
      this.$emit('filters-search');
    },
    /**
     * 点击导出按钮处理函数
     */
    async clickExportBtnHandler() {
      this.setProcessingShowState({ show: true });

      let params = '';
      // 参数值转换为url参数并修改部分key
      Object.keys(this.filters).forEach((key) => {
        if (this.filters[key] instanceof Array && this.filters[key].length > 0) {
          if (key === 'productGroupCodes') {
            params += `groupCodes=${this.filters[key].join(',')}&`;
          } else if (key === 'types') {
            params += `libraryTypes=${this.filters[key].join(',')}&`;
          } else {
            params += `${key}=${this.filters[key].join(',')}&`;
          }
        }

        if (typeof this.filters[key] === 'string' && this.filters[key]) {
          params += `${key}=${this.filters[key]}&`;
        }
      });

      if (this.deleteIds.length > 0) {
        params += `libraryIds=${this.deleteIds.join(',')}&`;
      }

      params = params.substring(0, params.length - 1);

      await this.$http.examcenter.libraryExportQuestion(params);

      this.setProcessingShowState({ show: false });
    },
    /**
     * 点击删除按钮处理函数
     */
    clickDeleteBtnHandler() {
      if (this.deleteIds.length === 0) {
        alert('未选择要删除的题目');
        return;
      }

      if (window.confirm('确认删除吗')) {
        this.requestDeleteQuestionAndRepull();
      }
    },
    /**
     * 点击待编辑题目按钮处理函数
     */
    clickWaitEditQuestionBtnHandler() {
      this.waitEditModal = true;
    },
    /**
     * 关闭待编辑题库题目列表弹层
     */
    closeWaitEditModal() {
      this.waitEditModal = false;
    },
    /**
     * 请求删除题库题目并重新请求列表
     */
    requestDeleteQuestionAndRepull() {
      this.requestDeleteQuestion()
        .then(() => {
          alert('删除成功');
          this.$emit('repull-list');
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求删除题库题目
     */
    requestDeleteQuestion() {
      return new Promise(async (resolve, reject) => {
        const params = {
          libraryIds: this.deleteIds.join(','),
        };

        const result = await this.$http.examcenter.libraryDeleteQuestion(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 上传题目表格文件前
     */
    questionExcelBeforeUpload() {
      this.setProcessingShowState({ show: true });
    },
    /**
     * 上传题目表格成功
     */
    questionExcelUploaded(result) {
      this.setProcessingShowState({ show: false });

      if (result.code === '200') {
        alert('上传成功');
        this.$emit('upload-success');
      } else {
        alert(result.msg);
      }
    },
    /**
     *  文件格式校验失败
     */
    uploadFileFormatError() {
      alert('上传文件格式未支持');
      this.setProcessingShowState({ show: false });
    },
    /**
     * 上传题目表格失败
     */
    questionExcelUploadFailed() {
      alert('上传失败');
      this.setProcessingShowState({ show: false });
    },
  },
};
</script>

<style lang="less" scoped>
.filter-action-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  &-left {
    margin-right: 80px;

    > button {
      margin-right: 16px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }

  &-right {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    > * {
      margin-left: 16px;
    }

    /deep/ .ivu-upload {
      display: flex;
    }
  }
}
</style>
